<template>
    <div :style="cssStyle">
        <div
            class="app-date-input"
            :class="{
                'label-is-up': filled,
                'has-error': error,
                manual: manual,
                modal: modal
            }"
        >
            <label v-if="!!label" :id="label">
                {{ label | __ }}
            </label>

            <app-datepicker
                :language="he"
                :placeholder="placeholderTrans"
                @selected="onInput"
                :value="value"
                format="dd/MM/yyyy"
                :open-date="openDate"
                :disabled-dates="disabledDates"
                v-if="!manual"
            >
            </app-datepicker>

            <masked-input
                class="masked-date-input"
                mask="11/11/1111"
                placeholder="__/__/____"
                v-model="maskedValue"
                v-else
            />

            <div class="loader" v-if="loading" v-html="$icon('loader')"></div>

            <div class="date-icon" v-if="icon" v-html="$icon(icon)"></div>
        </div>
        <p class="message" v-if="message">{{ message }}</p>
    </div>
</template>

<script>
import { he } from "vuejs-datepicker/dist/locale";
import MaskedInput from "vue-masked-input";

export default {
    name: "app-input",

    components: {
        MaskedInput
    },

    props: {
        type: {
            type: String,
            default: "text"
        },
        disabledDates: Object,
        value: [String, Number, Date],
        label: String,
        placeholder: String,
        openDate: [Date, false],
        error: Boolean,
        message: String,
        autofocus: Boolean,
        typeable: Boolean,
        manual: Boolean,
        modal: Boolean,
        loading: false,
        icon: false,
        disabled: false,
        cssStyle: {
            type: String,
            default: ""
        }
    },

    data() {
        return {
            newValue: this.value,
            maskedValue: "",
            focused: false,
            he: he
        };
    },

    mounted() {
        if (this.manual) {
            let manualDate;
            if (this.newValue) {
                manualDate = new Date(this.newValue);
                this.maskedValue = this.formatDate(manualDate);
            } else {
                manualDate = "__/__/____";
            }
        }
    },

    watch: {
        value() {
            this.newValue = this.value;
        },
        maskedValue(newVal) {
            if (!newVal) {
                return;
            }
            // console.log(newVal);
            const day = +newVal.split("/")[0] + 1;
            const month = newVal.split("/")[1] - 1;
            const year = newVal.split("/")[2];
            const fixedDate = new Date(year, month, day);

            if (fixedDate instanceof Date && !isNaN(fixedDate.valueOf())) {
                this.$emit("input", fixedDate);
                this.$emit("change", fixedDate);
            }
        }
    },

    methods: {
        formatDate(date) {
            const month = (date.getMonth() + 1).toString().padStart(2, "0");
            const day = (date.getDate() - 1).toString().padStart(2, "0");
            const year = date.getFullYear();

            return `${day}/${month}/${year}`;
        },
        onInput(e) {
            // console.log(e);
            this.$emit("input", e);
            this.$emit("change", e);
        }
    },

    computed: {
        filled() {
            return this.newValue || this.focused;
        },

        placeholderTrans() {
            return this.placeholder ? this.trans(this.placeholder) : "";
        }
    }
};
</script>

<style lang="scss" scoped>
.app-date-input {
    display: block;
    position: relative;
    font-size: 25px;
    font-weight: $font-light;
    line-height: 0.8;
    color: $black;
    height: 50px;

    //border-bottom: 1px solid $medium-gray;

    &.manual {
        //border: solid $medium-gray 1px;
    }

    .masked-date-input {
        direction: ltr;
        font-size: 20px;
        text-align: right;
        border: none;
        outline: none;
        width: 100%;
        height: 100%;
        //margin: 0 10px;
        background: $lightest-gray;
        border-radius: 100px;
        padding-right: 20px;
    }

    &.modal {
        .masked-date-input {
            height: 50px;
            border: 1px solid rgba(33, 67, 146, 0.2);
        }
    }

    ::v-deep {
        .vdp-datepicker {
            height: 100%;

            > div:not(.vdp-datepicker__calendar) {
                height: 100%;
            }

            input {
                position: relative;
                z-index: 1;
                border: 0;
                display: block;
                width: 100%;
                font-size: 20px;
                font-weight: $font-light;
                color: $black;
                outline: none;
                padding: 6px 0;
                border-radius: 100px;
                padding-right: 20px;
                height: 50px;
                border: solid 1px $blue-gray !important;
                background: $lightest-gray;
            }
        }
    }

    label {
        display: flex;
        flex-direction: column;
        justify-content: center;
        z-index: 2;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        pointer-events: none;
        transition: all 0.2s ease-in-out;
        margin-bottom: 10px;
    }

    .loader {
        position: absolute;
        width: 1em;
        height: 1em;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        z-index: 3;

        ::v-deep svg {
            stroke: black;
        }
    }

    .date-icon {
        position: absolute;
        //width: 1em;
        //height: 1em;
        left: 20px;
        top: 50%;
        transform: translateY(-50%);
        z-index: 3;
        display: flex;
        align-items: center;
    }

    .line {
        position: absolute;
        display: block;
        left: 50%;
        width: 0;
        bottom: -1px;
        height: 1px;
        z-index: 3;
        transform: translateX(-50%);
        background-color: $primary-blue;
        transition: all 0.4s ease-in-out;
    }

    &.label-is-up {
        label {
            color: rgba(0, 0, 0, 0.6);
            text-align: right;
            font-weight: $font-bold;
            // transform: translateY(-90%);
            font-size: 15px;
        }

        .line {
            width: 100%;
        }
    }
}

.message {
    font-size: 1rem;
    margin: 10px 0 0;
    color: $error-red;
    font-weight: $font-normal;
}
</style>
